import { PROPOSAL_ACTIONS } from "@repo/core/constants/proposals";
import { ProposalCardStatusEnum } from "@repo/core/enums/proposals";
import { ProposalOptionsItemProps } from "@repo/core/screens/Proposals/screens/ProposalsSearch/components/ProposalOptionsSheet/ProposalOptionsItem/types";
import {
  buildProposalsOptionsBySituationCode,
  normalizeProposalSituationCode,
  type ProposalMenuOptions
} from "@repo/core/screens/Proposals/screens/ProposalsSearch/utils";
import { filterEnabledProposalActions } from "@repo/core/utils/proposalFeatureFlags";

const creditTableProposalsOptionsByEnum: Record<
  ProposalCardStatusEnum,
  ProposalMenuOptions
> = {
  [ProposalCardStatusEnum.APROVED]: [
    {
      label: "Ver proposta",
      icon: "eye",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Editar proposta",
      icon: "pen-square",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Efetivar proposta",
      icon: "verified",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Enviar para mesa de crédito",
      icon: "hand-holding-dollar",
      action: PROPOSAL_ACTIONS.SEND_TO_CREDIT_TABLE
    }
  ],
  [ProposalCardStatusEnum.REJECTED]: [
    {
      label: "Ver proposta",
      icon: "eye",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Editar proposta",
      icon: "pen-square",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Enviar para mesa de crédito",
      icon: "hand-holding-dollar",
      action: PROPOSAL_ACTIONS.SEND_TO_CREDIT_TABLE
    }
  ],
  [ProposalCardStatusEnum.IN_PROGRESS]: [
    {
      label: "Ver proposta",
      icon: "eye",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Editar proposta",
      icon: "pen-square",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    }
  ],
  [ProposalCardStatusEnum.EFFECTIVE]: [
    {
      label: "Ver proposta",
      icon: "eye",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Editar proposta",
      icon: "pen-square",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Solicitar reavaliação",
      icon: "dollar-magnifying-glass",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    }
  ],
  [ProposalCardStatusEnum.INACTIVE]: [
    {
      label: "Ver proposta",
      icon: "eye",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Editar proposta",
      icon: "pen-square",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Solicitar reavaliação",
      icon: "dollar-magnifying-glass",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    }
  ],
  [ProposalCardStatusEnum.APROVED_CREDIT_DESK]: [
    {
      label: "Ver proposta",
      icon: "eye",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Editar proposta",
      icon: "pen-square",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Efetivar proposta",
      icon: "verified",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Enviar para mesa de crédito",
      icon: "hand-holding-dollar",
      action: PROPOSAL_ACTIONS.SEND_TO_CREDIT_TABLE
    }
  ],
  [ProposalCardStatusEnum.REJECTED_CREDIT_DESK]: [
    {
      label: "Ver proposta",
      icon: "eye",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Editar proposta",
      icon: "pen-square",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    }
  ],
  [ProposalCardStatusEnum.ANALYSIS_CREDIT_DESK]: [
    {
      label: "Ver proposta",
      icon: "eye",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    }
  ],
  [ProposalCardStatusEnum.DRAFT]: [
    {
      label: "Continuar proposta",
      icon: "pen-square",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    },
    {
      label: "Deletar",
      icon: "trash",
      iconColor: "$error600",
      iconColorHover: "$error400",
      action: PROPOSAL_ACTIONS.SEE_PROPOSAL
    }
  ]
};

const creditTableProposalsOptionsBySituation = buildProposalsOptionsBySituationCode(
  creditTableProposalsOptionsByEnum
);

export const getCreditTableProposalOptionsBySituationCode = (
  code: string | undefined
): Omit<ProposalOptionsItemProps, "onPress">[] => {
  const normalized = normalizeProposalSituationCode(code);
  const byCode = creditTableProposalsOptionsBySituation[normalized];
  if (byCode?.length) {
    return filterEnabledProposalActions(byCode).map((o) => ({ ...o }));
  }
  const fallback =
    creditTableProposalsOptionsByEnum[ProposalCardStatusEnum.IN_PROGRESS];
  return filterEnabledProposalActions(fallback ?? []).map((o) => ({ ...o }));
};
